export const PRODUCT_AVAILABILITY = {
  AVAILABLE_NOW: "available_now",
  COMING_SOON: "coming_soon",
  MADE_TO_ORDER: "made_to_order",
  OUT_OF_STOCK: "out_of_stock",
  ARCHIVED: "archived",
};

export const PRODUCT_AVAILABILITY_OPTIONS = [
  { value: PRODUCT_AVAILABILITY.AVAILABLE_NOW, label: "Available Now" },
  { value: PRODUCT_AVAILABILITY.COMING_SOON, label: "Coming Soon" },
  { value: PRODUCT_AVAILABILITY.MADE_TO_ORDER, label: "Made to Order" },
  { value: PRODUCT_AVAILABILITY.OUT_OF_STOCK, label: "Out of Stock" },
];

export const PRODUCT_AVAILABILITY_FILTERS = [
  { value: "active_future", label: "Available, Made to Order & Coming Soon" },
  { value: PRODUCT_AVAILABILITY.AVAILABLE_NOW, label: "Available Now" },
  { value: PRODUCT_AVAILABILITY.COMING_SOON, label: "Coming Soon" },
  { value: PRODUCT_AVAILABILITY.MADE_TO_ORDER, label: "Made to Order" },
  { value: PRODUCT_AVAILABILITY.OUT_OF_STOCK, label: "Out of Stock" },
];

export const FARM_STAND_AVAILABILITY_OPTIONS = [
  { value: "open_now", label: "Open Now" },
  { value: "opening_soon", label: "Opening Soon" },
  { value: "closed_for_season", label: "Closed for Season" },
];

export const FRESH_FIND_STATUS = {
  OPEN: "open",
  SELF_SERVE: "self_serve",
  CLOSED: "closed",
};

export const FRESH_FIND_STATUS_OPTIONS = [
  { value: FRESH_FIND_STATUS.OPEN, label: "Open" },
  { value: FRESH_FIND_STATUS.SELF_SERVE, label: "Self-Serve" },
  { value: FRESH_FIND_STATUS.CLOSED, label: "Closed" },
];

export const normalizeFreshFindStatus = (status) => {
  const value = String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (["open", "open_now", "available", "available_now"].includes(value)) {
    return FRESH_FIND_STATUS.OPEN;
  }

  if (["selfserve", "self_serve", "self_service", "self_served", "24_7", "24/7"].includes(value)) {
    return FRESH_FIND_STATUS.SELF_SERVE;
  }

  if (
    [
      "closed",
      "closed_for_season",
      "opening_soon",
      "unavailable",
      "out_of_stock",
      "inactive",
    ].includes(value)
  ) {
    return FRESH_FIND_STATUS.CLOSED;
  }

  return "";
};

export const getFreshFindStatusFromStandAvailability = (status) =>
  normalizeFreshFindStatus(status) || FRESH_FIND_STATUS.CLOSED;

export const LAND_AVAILABILITY_OPTIONS = [
  { value: "available_now", label: "Available Now" },
  { value: "available_starting", label: "Available Starting" },
];

export const EVENT_REGISTRATION_OPTIONS = [
  { value: "open", label: "Registration Open" },
  { value: "opens_later", label: "Registration Opens Later" },
  { value: "closed", label: "Registration Closed" },
];

export const SERVICE_AVAILABILITY_OPTIONS = [
  { value: "available", label: "Available" },
  { value: "limited", label: "Limited Availability" },
  { value: "seasonal", label: "Seasonal Availability" },
  { value: "unavailable", label: "Currently Unavailable" },
];

export const getProductAvailabilityStatus = (item = {}) => {
  if (item.availabilityStatus) return item.availabilityStatus;
  if (item.status === "archived" || item.isArchived === true) {
    return PRODUCT_AVAILABILITY.ARCHIVED;
  }
  if (item.status === "out_of_stock" || Number(item.quantityAvailable ?? item.quantity ?? 1) <= 0) {
    return PRODUCT_AVAILABILITY.OUT_OF_STOCK;
  }
  return PRODUCT_AVAILABILITY.AVAILABLE_NOW;
};

export const getProductAvailabilityLabel = (status) =>
  [
    ...PRODUCT_AVAILABILITY_OPTIONS,
    { value: PRODUCT_AVAILABILITY.ARCHIVED, label: "Archived" },
  ].find((option) => option.value === status)?.label || "Available Now";

export const getFarmStandAvailabilityLabel = (status) =>
  FARM_STAND_AVAILABILITY_OPTIONS.find((option) => option.value === status)?.label || "Open Now";

export const getLandAvailabilityLabel = (status) =>
  LAND_AVAILABILITY_OPTIONS.find((option) => option.value === status)?.label || "Available Now";

export const getEventRegistrationLabel = (status) =>
  EVENT_REGISTRATION_OPTIONS.find((option) => option.value === status)?.label || "Registration Open";

export const getServiceAvailabilityLabel = (status) =>
  SERVICE_AVAILABILITY_OPTIONS.find((option) => option.value === status)?.label || "Available";
